import React, { useEffect } from 'react';
import ReactGA from 'react-ga';
import Page from '../../components/library/Page';
import ConstantValues from '../../constants/ConstantValues';
import { Grid, Typography } from '@mui/material';
import { SEO } from '../../common';
import { formatSEOTitle } from '../../function';
import { useTranslation } from 'react-i18next';

/* @ts-expect-error */
function QuestionAndAnswer(question, answer) {
  return { question, answer };
}

function FAQ() {
  const { t } = useTranslation();
  
  const questionAndAnswers = [
    QuestionAndAnswer(
      t('faq_question_1'),
      t('faq_answer_1'),
    ),
    QuestionAndAnswer(
      t('faq_question_2'),
      t('faq_answer_2'),
      ),
      QuestionAndAnswer(
      t('faq_question_3'),
      t('faq_answer_3'),
    ),
    // Additional comprehensive FAQs
    QuestionAndAnswer(
      t('faq_question_4'),
      t('faq_answer_4')
    ),
    QuestionAndAnswer(
      t('faq_question_5'),
      t('faq_answer_5')
    ),
    QuestionAndAnswer(
      t('faq_question_6'),
      t('faq_answer_6')
    ),
    QuestionAndAnswer(
      t('faq_question_7'),
      t('faq_answer_7')
    ),
    QuestionAndAnswer(
      t('faq_question_8'),
      t('faq_answer_8')
    ),
    QuestionAndAnswer(
      t('faq_question_9'),
      t('faq_answer_9')
    ),
    QuestionAndAnswer(
      t('faq_question_10'),
      t('faq_answer_10')
    ),
    QuestionAndAnswer(
      t('faq_question_11'),
      t('faq_answer_11')
    ),
    QuestionAndAnswer(
      t('faq_question_12'),
      t('faq_answer_12')
    ),
    QuestionAndAnswer(
      t('faq_question_13'),
      t('faq_answer_13')
    ),
    QuestionAndAnswer(
      t('faq_question_14'),
      t('faq_answer_14')
    ),
    QuestionAndAnswer(
      t('faq_question_15'),
      t('faq_answer_15')
    ),
    QuestionAndAnswer(
      t('faq_question_16'),
      t('faq_answer_16')
    ),
    QuestionAndAnswer(
      t('faq_question_17'),
      t('faq_answer_17')
    ),
    QuestionAndAnswer(
      t('faq_question_18'),
      t('faq_answer_18')
    )
  ];
  
  useEffect(() => {
    if (document.location.hostname === ConstantValues.SiteHostname) {
      ReactGA.pageview(window.location.pathname);
    }
  }, []);

  const Content = () => {
    return (
      <>
        <Typography variant="body1" gutterBottom component="div" style={{marginBottom: '30px', fontSize: '1.1rem'}}>
          {t('faq_intro')}
        </Typography>
        
        <Grid container spacing={4}>
          {questionAndAnswers.map((item, index) => (
            <React.Fragment key={index}>
              <Grid item xs={12} md={4}>
                <Typography variant="h6" style={{color: '#1976d2', fontWeight: 'bold'}}>{item.question}</Typography>
              </Grid>
              <Grid item xs={12} md={8}>
                <Typography variant="body1" style={{lineHeight: 1.6}}>{item.answer}</Typography>
              </Grid>
              {index < questionAndAnswers.length - 1 && (
                <Grid item xs={12}>
                  <hr style={{border: 'none', height: '1px', backgroundColor: '#e0e0e0', margin: '10px 0'}} />
                </Grid>
              )}
            </React.Fragment>
          ))}
        </Grid>
        
        <div style={{marginTop: '40px', padding: '25px', backgroundColor: '#f8f9fa', borderRadius: '8px', border: '1px solid #e9ecef'}}>
          <Typography variant="h6" gutterBottom style={{color: '#495057'}}>{t('faq_still_questions_title')}</Typography>
          <Typography variant="body1" style={{color: '#6c757d', marginBottom: '15px'}}>
            {t('faq_still_questions_description')}
          </Typography>
          <Typography variant="body1" style={{color: '#6c757d'}}>
            {t('faq_guides_description')}
          </Typography>
        </div>
      </>
    );
  };

  return (
    <Page pageTitle="Signal Sticker Maker FAQ - Custom Stickers Help">
      {/* @ts-expect-error */}
      <SEO
        title={formatSEOTitle('Signal Sticker Maker FAQ - Custom Stickers Questions & Answers')}
        description='Frequently asked questions about creating custom stickers for Signal messaging app. Get help with our free signal sticker maker tool, image formats, and troubleshooting.'
      />
      <Content/>
    </Page>
  );
}

export default FAQ;
